angular.module("avant.filters").filter "LeftPad", ->
  (input, length, char = ' ') ->
    length = _.max [input.length, length] if input
    (("0" for x in [1..length]).join('') + (input or "")).slice(-length)
